import {useLayoutEffect} from 'react';
import {usePersistentStore} from 'stores';

const useTheme = () => {
  const theme = usePersistentStore(s => s.theme);
  const setTheme = usePersistentStore(s => s.setTheme);

  useLayoutEffect(() => {
    document.querySelector('body')?.setAttribute('data-theme', theme);
    if (theme === 'system') {
      const isSystemDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      const systemTheme = isSystemDark ? 'dark' : 'light';
      document.querySelector('body')?.setAttribute('data-theme', systemTheme);
      setTheme(systemTheme);
    }
  }, [theme, setTheme]);

  return {theme};
};

export default useTheme;
